import React, { Fragment } from 'react';
import { connect } from "react-redux";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import ModalHeading from '../ModalHeading';
import ButtonContent from '../ButtonContent';
import withAuth from '../../hocs/withAuth';
import { COLORS } from '../../styles/colors'
import AddIcon from '@material-ui/icons/Add';
import { Link } from "react-router-dom";
import StartCalendar from "./StartCalendar";
import EndCalendar from "./EndCalendar";
import TreeView from "./TreeView";
import ActionForm from './ActionForm';
import ActionListing from './../assignments/ActionsListing';
import MileStones from './../assignments/Milestones';
import ScheduleCall from './../assignments/ScheduleCall';
import BodyMatrix from './../assignments/BodyMatrix';
import WeightMetric from './../assignments/WeightMetric';
import ParQ from './../assignments/ParQ';
import moment from 'moment';
import { AlertJsMessage, ConfirmJsMessage } from './../../helpers.js';


class ClientActionPlan extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show: props.isOpenAddModal,
            formData: {
                title: ''
            },
            selectedTab: this.props.isMobile ? 'bodyMatrix' : 'committedAction',
            actions: [],
            isOpenForm: false,
            isOpenViewAction: false,
        }
        this.prepareData = [];
    }

    selectedTab = (path) => {
        this.setState({
            selectedTab: path
        })
    }

    
    makeid(length) {
        var result = '';
        var characters = '0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    
    onClose = () => this.setState({ show: false }, () => this.props.hideActionModal());
    

    renderTabs = () => {

        let links = [
            { text: 'Commited Action', path: 'committedAction' },
            { text: 'Deadline', path: 'scheduleCall' },
            { text: 'Milestones', path: 'milestones' },
            { text: 'Functional Strength', path: 'bodyMatrix' },
            { text: 'Weight Metric', path: 'weightMetric' },
            { text: 'PAR-Q', path: 'parQ' },
        ]

        if(this.props.isMobile) {
            links = [
                { text: 'Functional Strength', path: 'bodyMatrix' },
                { text: 'Weight Metric', path: 'weightMetric' },
                { text: 'PAR-Q', path: 'parQ' },
            ]
        }

        return(<div style={{ width: '100%', borderBottom: '1px solid ' + COLORS.grey, paddingBottom: 6, marginBottom: 20, fontSize: 14 }}>
              {
                links.map((link, i) => (
                  <a key={i} >
                    <span style={{
                      color: COLORS.black,
                      padding: 6,
                      marginRight: 25,
                      borderBottom: this.state.selectedTab === link.path ? '5px solid ' + COLORS.orange : ''
                    }} onClick={() => this.selectedTab(link.path)}>
                      {link.text}
                    </span>
                  </a>
                ))
              }
        </div>)
    }

    addData = () => {
      this.setState({
        isOpenForm: true,
        actionType: 'Action',
        formData: {
            title: ''
        }
      })
    }

    viewHistory = () => {
        this.setState({
           isOpenViewAction: !this.state.isOpenViewAction
        })
    }

    onEditAction = (data) => {
        this.setState({
            isOpenForm: true,
            actionType: 'Action',
            formData: {
                title: data.path,
                _id: data._id,
                clientId: data.clientId
            }
        })
    }

    onSave = () => {
       let { formData, week, year, actions } = this.state;
       const required = ['title'];
        for (var i = 0; i < required.length; i++) {
            if (!formData[required[i]]) {
                AlertJsMessage('Action is required.');
                return;
            }
       }
       if (formData.clientId) {
          const findIndex = actions.findIndex((action) => {
              return action.clientId === formData.clientId
          })
          actions[findIndex] = {
              ...actions[findIndex],
              path: formData.title,
              isDelete: false
          }
       } else {
          actions.push({
            path: formData.title,
            type: "tree",
            tree: [],
            clientId: this.makeid(10),
            isDelete: false
          })
       }
       this.setState({
            actions: [...actions],
            isOpenForm: false,
            formData: {
                ...formData,
                clientId: this.makeid(10)
            }
        })
        this.prepareData = actions
    }

    onDeleteAction = (clientId) => {
        if (ConfirmJsMessage(`Are you sure you want to delete the action?`)) {
            let { actions } = this.state;
            const findIndex = actions.findIndex((action) => {
                return action.clientId === clientId
            })
            actions[findIndex] = {
                ...actions[findIndex],
                isDelete: true
            }
            this.prepareData = actions
            this.setState({
                actions: [...actions],
            })
        }
    }

    handleChange = event => {
		const { name, value } = event.target;
		this.setState({
			formData: {
				...this.state.formData,
				[name]: value,
			},
		});
	};

    passData = (clientId, subData) => {
        let prepareData = this.prepareData;
        const findIndex = prepareData.findIndex((action) => {
            return action.clientId === clientId
        });
        if (findIndex > -1) {
            const tree = prepareData[findIndex]['tree'];
            const subClientId = subData['clientId'];
            const subIndex = tree.findIndex((sub) => {
                return sub.clientId === subClientId
            });
            if (subIndex > -1) {
                tree[subIndex] = subData;
            } else {
                tree.push(subData)
            }
            prepareData[findIndex]['tree']  = tree;
            this.prepareData = prepareData
        }
    }

    addDays = (dateObj, numDays) => {
        return dateObj.setDate(dateObj.getDate() + numDays);
    }

    changeStartDate = (data) => {
        const date = new Date(data);
        const values = [
            this.addDays(new Date(data), 0),
            this.addDays(new Date(data), 1),
            this.addDays(new Date(data), 2),
            this.addDays(new Date(data), 3),
            this.addDays(new Date(data), 4),
            this.addDays(new Date(data), 5),
            this.addDays(new Date(data), 6),
        ]
        this.setState({
            endDateValues: values,
            startDate: moment(date).format('YYYY-MM-DD'),
            endDate: moment(this.addDays(new Date(data), 6)).format('YYYY-MM-DD')
        })
    }

    submitData = () => {
        let prepareData = this.prepareData;
        prepareData = prepareData.map((data, index) => {
            let tree = data.tree;
            if (tree.length) {
                tree = tree.map((t,index) => {
                    return {
                        ...t,
                        subOrderId: index+ 1
                    }
                })
            }
            return {
                ...data,
                orderId: index + 1,
                tree: tree
            }
        });
        this.props.saveClientAction({
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            actions: prepareData,
            clientEmail: this.props.clientEmail,
            isDateChange: true,
            isActionChange: true
        })
        .then((res) => {
           this.setState({
                actions: []
           })
           this.prepareData = [];
        })
    
    }

    render() {
        let { clientType, isMobile } = this.props;
        const { show, isOpenForm, actionType, formData, actions, isOpenViewAction, selectedTab } = this.state;
        const filterActions = actions.filter((action) => !action.isDelete)
        return (
            <Modal
                className="modal show"
                open={show}
                onClose={this.onClose}
            >
                <div className="modalBody modal-content" style={{ width: isMobile ? '90%' : 850, minHeight: isMobile ? 400 : 600 }}>
                        <Fragment>
                            <ModalHeading
                                text={'Action Plan'}
                                closeModal={this.onClose}
                            />
                            <div className="modalContent">
                               {isOpenForm && (
                                    <ActionForm
                                        clientType={clientType}
                                        isEdit={false}
                                        hideAddModal={() => {
                                            this.setState({
                                                isOpenForm: false
                                            })
                                        }}
                                        isOpenFormModal = {isOpenForm}
                                        onChange={this.handleChange}
                                        actionType = {actionType}
                                        formData={formData}
                                        onSave={() => this.onSave()}
                                    />
                                )}
                                
                                {this.renderTabs()}
                                {
                                    selectedTab === 'committedAction' ?
                                        <Fragment>
                                            <div style={{
                                                        marginTop: '5px',
                                                        textAlign: 'right'
                                                    }}>
                                                <Button
                                                    color="primary"
                                                    onClick={() => this.viewHistory()}
                                                    style={{
                                                        color: COLORS.orange,
                                                        fontSize: '10px'
                                                    }}
                                                >
                                                    <ButtonContent text={ !isOpenViewAction ? "View History" : "Back" }  />
                                                </Button>
                                            </div>  
                                            { isOpenViewAction && (
                                                <ActionListing 
                                                    fetchActionRanges = { this.props.fetchActionRanges} 
                                                    clientEmail = {this.props.clientEmail}
                                                    fetchActions = { this.props.fetchActions }
                                                    saveClientAction = { this.props.saveClientAction }
                                                    deleteActionRange = { this.props.deleteActionRange }
                                                >
                                                </ActionListing>) 
                                            }
                                            { !isOpenViewAction && (
                                                <Fragment>
                                                    <div style={{
                                                        display: 'flow-root',
                                                        padding: 20,
                                                        paddingLeft: 0,
                                                        width: '100%',
                                                        height: '90px'
                                                        }}>
                                                        <div style={{
                                                            display: 'initial',
                                                            float: 'left'
                                                        }}>
                                                        <p>Start Date</p>
                                                            <StartCalendar bottomLeftPosition={true} changeStartDate={this.changeStartDate} showDetailsHandle={this.showDetailsHandle} />
                                                        </div>
                                                        <div style={{
                                                            display: 'initial',
                                                            float: 'left',
                                                            marginLeft: '10px'
                                                        }}>
                                                        <p>End Date</p>
                                                            <EndCalendar endDateValues={this.state.endDateValues} showDetailsHandle={this.showDetailsHandle} />
                                                        </div>
                                                    </div>
                                                    <div style={{
                                                                marginTop: '5px',
                                                            }}>
                                                        <Button
                                                            color="primary"
                                                           
                                                            onClick={() => this.addData()}
                                                        >
                                                            <ButtonContent text="Add Action" icon="plus"  />
                                                        </Button>
                                                    </div>
                                                    {filterActions.map((item, index) => {
                                                        return (
                                                        <Fragment>
                                                            <TreeView 
                                                                onEditAction = {this.onEditAction} 
                                                                saveClientSubAction={this.props.saveClientSubAction} 
                                                                onDeleteAction = { this.onDeleteAction }
                                                                passData = { this.passData }
                                                                key={index}
                                                                item = {item}>
                                                            </TreeView>
                                                        </Fragment>
                                                        )
                                                    })}
                                                    { filterActions.length > 0 &&
                                                        <div style={{
                                                                    marginTop: '5px',
                                                                }}>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() => this.submitData()}
                                                        >
                                                            <ButtonContent
                                                                text="Submit"
                                                                icon="chevron-right" />
                                                        </Button>
                                                        </div>
                                                    }
                                                </Fragment>)
                                            }
                                    </Fragment>
                                : selectedTab === 'milestones' ?
                                    <MileStones 
                                        clientEmail = {this.props.clientEmail}
                                        fetchMileStones = { this.props.fetchMileStones }
                                        saveMileStones = { this.props.saveMileStones }
                                        deleteMileStones = { this.props.deleteMileStones }
                                        updateActionStatus = {this.props.updateActionStatus}
                                    > 
                                    </MileStones>
                                    : selectedTab === 'weightMetric' ?  
                                    <WeightMetric 
                                        clientEmail = {this.props.clientEmail}
                                        user = {this.props.user}
                                        fetchWeightMetric = { this.props.fetchWeightMetric }
                                        saveWeightMetric = {this.props.saveWeightMatric}
                                        fetchWeightMetricRanges = { this.props.fetchWeightMetricRanges }
                                        deleteWeightMetricRange = {this.props.deleteWeightMetricRange}
                                        isMobile = {this.props.isMobile}
                                    > </WeightMetric>
                                    : selectedTab === 'scheduleCall' ?  
                                    <ScheduleCall 
                                        clientEmail = {this.props.clientEmail}
                                        fetchScheduleCall = { this.props.fetchScheduleCall }
                                        saveScheduleCall = { this.props.saveScheduleCall }
                                    >  
                                    </ScheduleCall> :   selectedTab === 'bodyMatrix' ?  
                                    <BodyMatrix 
                                        clientEmail = {this.props.clientEmail}
                                        user = {this.props.user}
                                        fetchBodyMatrixMetas = { this.props.fetchBodyMatrixMetas}
                                        fetchBodyMatrix = { this.props.fetchBodyMatrix }
                                        saveBodyMatrix = {this.props.saveBodyMatrix}
                                        fetchBodyMatrixRanges = { this.props.fetchBodyMatrixRanges }
                                        deleteBodyMatrixRange = {this.props.deleteBodyMatrixRange}
                                        isMobile = {this.props.isMobile}
                                    /> : selectedTab === 'parQ' ?  
                                    <ParQ 
                                        clientEmail = {this.props.clientEmail}
                                        user = {this.props.user}
                                        fetchPARQS = { this.props.fetchPARQS }
                                        savePARQ = {this.props.savePARQ}
                                        deletePARQ = {this.props.deletePARQ}
                                        isMobile = {this.props.isMobile}
                                        item = {{}}
                                    /> : ''
                                }
                             </div>
                        </Fragment>
                </div>
            </Modal>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        errors: state.errors
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withAuth(ClientActionPlan));



// WEBPACK FOOTER //
// ./src/components/assignments/ClientActionPlan.js